import { Row, Select } from 'antd'
import styled, { createGlobalStyle } from 'styled-components'
import { colors } from 'web-makeup/dist/design-system/config/data/theme'

import { SMALL_BREAKPOINT, XSMALL_BREAKPOINT } from '../../style'

export const AntdGlobalStyles = createGlobalStyle`
  .ant-calendar-date.ant-calendar-date.ant-calendar-date {
    border-radius: 50%;
    width: 2rem;
    height: 2rem;
    display: flex;
    justify-content: center;
    align-items: center;
    color: ${colors.black1};
    background: none;

    &:hover {
      background: ${colors.adaptBlue};
      border-color: ${colors.adaptBlue};
      color: white;
    }
  }
  .ant-calendar-selected-date{
    .ant-calendar-date.ant-calendar-date.ant-calendar-date {
      background: ${colors.adaptBlue};
      border-color: ${colors.adaptBlue};
      color: white;
    }
  }
  .ant-calendar-input-wrap, .ant-calendar-footer {
    display: none;
  }
  .ant-calendar.ant-calendar.ant-calendar {
    background: ${colors.gandalf};
    padding: 0.75rem;
    font-size: 0.75rem;
    line-height: 2;
    border-radius: 0.5rem;
  }
  .ant-calendar-disabled-cell {
    .ant-calendar-date.ant-calendar-date.ant-calendar-date  {
      background: none !importent;
      border: none !importent;
      color: ${colors.dawn};

      &::before {
        border: none;
      }

      &:hover {
        background: none;
        border: none;
        color: ${colors.dawn};
      }
    }
  }

  .ant-calendar-today .ant-calendar-date {
    border: none;
  }
  .ant-select-dropdown-menu-item:hover {
    && {
      background: ${colors.adaptBlue};
      color: white;
    }
  }
  .ant-select-selection__placeholder.ant-select-selection__placeholder {
    color: ${colors.nebula};
  }

  .react-calendar{
    background: ${colors.dust};
    padding: 0.75rem;
    max-width: 15rem;
    font-size: 0.75rem;
    line-height: 2;
    border-radius: 0.5rem;
    position: absolute;
    z-index: 1;
    top: 82px;
  }
  .react-calendar__tile--rangeStart {
    background: ${colors.adaptBlue};
    color: white;
    font-weight: 700;
  }
  .react-calendar__tile {
    border-radius: 100%;
    width: 2rem;
    height: 2rem;
    padding: 0;
    /* stylelint-disable */
    max-width: 2rem !important;
    /* stylelint-enable */

    &:hover {
      background: ${colors.adaptBlue};
      color: white;
    }

    &.react-calendar__year-view__months__month,
    &.react-calendar__decade-view__years__year,
    &.react-calendar__century-view__decades__decade {
      border-radius: 3px;
    }

    &:disabled,
    &[disabled] {
      color: ${colors.dawn};
      &:hover {
        background: none;
        color: ${colors.dawn};
      }
    }
  }
  .react-calendar__month-view__weekdays__weekday {
    font-weight: 700;
    font-size: 10px;
    line-height: 12px;
    color: ${colors.black1};
    text-transform: uppercase;
    display: flex;
    justify-content: center;

    abbr {
      text-decoration: none;
    }
  }
  .react-calendar.hide {
    display: none;
  }

  .ant-modal {
    max-width: 100%;
  }

  .ant-modal-body.ant-modal-body.ant-modal-body {
    h3 {
      margin-bottom: 0.375rem;
    }
    p {
      margin-bottom: 1rem;
    }
    button:first-of-type {
      margin-right: 1rem;
    }

    @media all and (max-width: ${XSMALL_BREAKPOINT}) {
      button {
        margin: 0 auto;
        display: block;
        margin-bottom: 0.5rem;
      }
      button:first-of-type {
        margin-right: auto;
      }
    }    
  }

  .ant-modal-content.ant-modal-content.ant-modal-content {
    border-radius: 0.5rem;
    overflow: hidden;
  }
  
  .ant-modal-close.ant-modal-close.ant-modal-close {
    display: none;
  }
`
export const Container = styled.div`
  padding: 7.75rem 3.375rem 0;
  display: flex;
  margin: 0 auto;
  background: ${colors.dust};
  width: 100%;
  justify-content: center;

  @media all and (max-width: ${SMALL_BREAKPOINT}) {
    flex-direction: column-reverse;
    padding: 6.75rem 1.25rem 1.25rem;
  }
`
export const Sidebar = styled.div`
  width: 15rem;
  margin-right: 5.375rem;

  h1 {
    text-align: center;
    margin-bottom: 1.5rem;
  }

  h4 {
    margin-bottom: 0.5rem;
  }

  @media all and (max-width: ${SMALL_BREAKPOINT}) {
    width: 100%;

    h4 {
      font-size: 1.125rem;
    }
  }
`
export const Avatar = styled.div<{ source: string }>`
  background: ${({ source }) =>
    source === '' ? colors.gandalf : `url(${source}) no-repeat center`};
  height: 7.75rem;
  width: 7.75rem;
  border-radius: 50%;
  background-size: cover;
  margin: 0 auto 0.75rem;
`
export const Main = styled.div`
  width: 60rem;

  @media all and (max-width: ${SMALL_BREAKPOINT}) {
    width: 100%;
    padding-top: 1.5rem;
  }

  h2 {
    margin-bottom: 1rem;

    @media all and (max-width: ${SMALL_BREAKPOINT}) {
      margin-bottom: 0.5rem;
    }
  }
`
export const H2 = styled.h2`
  font-weight: 900;
  font-size: 1.5rem;
  line-height: 2.125rem;
  color: ${colors.black1};
  text-align: center;
`
export const H3 = styled.h2`
  font-weight: 900;
  font-size: 1rem;
  line-height: 1.625rem;
`
export const BrandCard = styled.div`
  background: white;
  box-shadow: 0 2px 48px rgba(0, 0, 0, 0.1);
  border-radius: 0.75rem;
  padding: 0 1rem;
  width: 15rem;
  height: 6rem;
  display: flex;
  position: relative;
  align-items: center;
  margin-bottom: 0.75rem;
  cursor: pointer;

  picture {
    position: absolute;
    right: 1rem;
    top: 50%;
    transform: translate(0%, -50%);
  }

  h4 {
    margin: 0;
    max-width: 8.125rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  @media all and (max-width: ${SMALL_BREAKPOINT}) {
    max-width: 100%;
    width: 100%;
  }
`
export const Logo = styled.div<{ source: string }>`
  background: ${({ source }) =>
    source === '' ? colors.gandalf : `url(${source}) no-repeat center`};
  background-size: cover;
  height: 3rem;
  width: 3rem;
  border-radius: 50%;
  margin-right: 0.625rem;
`
export const Signin = styled.div`
  text-align: center;

  p {
    font-weight: 600;
    font-size: 0.875rem;
    line-height: 1.125rem;
    margin-bottom: 1.5rem;
    color: ${colors.black1};

    @media all and (max-width: ${SMALL_BREAKPOINT}) {
      margin-bottom: 0;
      border-bottom: 1px solid ${colors.gandalf};
      padding-bottom: 2rem;
      margin-right: -1.25rem;
      margin-left: -1.25rem;
    }
  }

  button {
    font-weight: 600;
    font-size: 0.875rem;
    line-height: 1.125rem;
    height: 2rem;
    padding: 0 0.75rem;
    background: ${colors.gandalf};
    border-radius: 0.25rem;
    color: ${colors.black1};

    @media all and (max-width: ${SMALL_BREAKPOINT}) {
      display: none;
    }
  }
`
export const WhiteBox = styled.div`
  background: white;
  border: 1px solid ${colors.gandalf};
  box-sizing: border-box;
  border-radius: 0.75rem;
  padding: 2.25rem;
  margin-bottom: 2.25rem;
  color: ${colors.black1};

  @media all and (max-width: ${XSMALL_BREAKPOINT}) {
    margin-bottom: 2rem;
  }
`
export const BrandInfo = styled.div`
  display: flex;
  margin-bottom: 1.25rem;
`
export const LogoWrapper = styled.div<{ source: string }>`
  width: 6.5rem;
  height: 6.5rem;
  min-width: 6.5rem;
  margin-right: 1.25rem;
  border-radius: 50%;
  position: relative;
  border: 1.5px dashed ${colors.gandalf};

  &::after {
    content: '';
    position: absolute;
    top: 0.438rem;
    bottom: 0.438rem;
    right: 0.438rem;
    left: 0.438rem;
    background: url(${({ source }) => source}) no-repeat center;
    background-size: cover;
    border-radius: 50%;

    @media all and (max-width: ${XSMALL_BREAKPOINT}) {
      top: 0.313rem;
      bottom: 0.313rem;
      right: 0.313rem;
      left: 0.313rem;
    }
  }

  @media all and (max-width: ${XSMALL_BREAKPOINT}) {
    width: 4.75rem;
    height: 4.75rem;
    min-width: 4.75rem;
    padding: 0.25rem;
  }
`
export const Info = styled.div`
  max-width: 26rem;

  input {
    display: none;
  }

  h3 {
    font-weight: 700;
    font-size: 0.875rem;
    line-height: 1.5rem;
  }

  p {
    font-size: 0.75rem;
    line-height: 1rem;
    color: ${colors.dawn};
    margin-bottom: 0.625rem;
  }

  a {
    font-weight: 600;
    font-size: 0.875rem;
    line-height: 1.125rem;
    color: ${colors.adaptBlue} !important; /* stylelint-disable-line */
  }
`
export const StyledRow = styled(Row)`
  margin-bottom: 1.25rem;

  @media all and (max-width: ${XSMALL_BREAKPOINT}) {
    display: block;
    margin-bottom: 0;
  }

  > div {
    @media all and (max-width: ${XSMALL_BREAKPOINT}) {
      margin-bottom: 1rem;
    }
  }

  .ant-select {
    width: 100%;
  }
`
export const Input = styled.input`
  border: 1px solid ${colors.radagast};
  height: 2.75rem;
  color: ${colors.black1};
  font-size: 0.875rem;
  border-radius: 6px;
  width: 100%;
  padding: 0 1rem;
  transition: all 0.3s ease;

  &.filled {
    border-color: ${colors.gandalf};
    background: ${colors.gandalf};
  }

  &:focus {
    border-color: ${colors.black1};
    background: ${colors.white};
  }
`
export const InputLabel = styled.h4`
  font-size: 0.875rem;
  font-weight: 700;
  line-height: 1.5rem;
  color: ${colors.black1};
  text-transform: none;
  margin-bottom: 0.375rem;

  &::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: ${colors.saruman};
    opacity: 1; /* Firefox */
  }

  /* stylelint-disable */
  &:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: ${colors.saruman};
  }

  &::-ms-input-placeholder {
    /* Microsoft Edge */
    color: ${colors.saruman};
  }
  /* stylelint-enable */
`
export const ButtonWrapper = styled.div`
  display: flex;
`
export const PasswordSection = styled.div`
  background: ${colors.dust};
  border-radius: 0.5rem;
  padding: 1.5rem;
  margin-top: 1.25rem;
`
export const AddButton = styled.div`
  margin-bottom: 20rem;

  img {
    margin: 0 auto;
    display: block;
    cursor: pointer;
  }

  @media all and (max-width: ${SMALL_BREAKPOINT}) {
    margin-bottom: 2rem;
  }
`
export const StyledSelect = styled(Select as any)`
  .ant-select-selection.ant-select-selection.ant-select-selection {
    border: 1px solid ${colors.radagast};
    height: 2.75rem;
    color: ${colors.black1};
    font-size: 0.875rem;
    border-radius: 6px;
    width: 100%;
    padding: 0 1rem;
    text-transform: capitalize;

    .ant-select-selection__rendered {
      margin: 0;
      color: ${colors.black1};
      height: 2.75rem;
      display: flex;
      align-items: center;
    }
  }

  &.filled .ant-select-selection.ant-select-selection.ant-select-selection {
    border-color: ${colors.gandalf};
    background: ${colors.gandalf};
  }
  &&&.ant-select-open .ant-select-selection,
  &&&.ant-select-focused .ant-select-selection,
  &&& .ant-select-selection:focus,
  &&& .ant-select-selection:active {
    box-shadow: none;
    border-color: ${colors.black1};
    background: ${colors.white};
    color: ${colors.black1};
  }

  &&&.tagsSelect {
    margin-bottom: 2rem;

    .ant-select-selection__rendered {
      position: absolute;
      bottom: -50px;
      left: 0;
    }
  }

  .ant-select-selection__choice {
    height: 2rem;
    background: ${colors.black1};
    color: white;
    font-size: 0.875rem;
    line-height: 1.5rem;
    padding: 0 2rem 0 0.75rem;
    border-radius: 4.375rem;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    position: relative;
    cursor: pointer;
    text-transform: capitalize;
  }
`
export const MobileAvatar = styled.div`
  display: none;

  @media all and (max-width: ${SMALL_BREAKPOINT}) {
    display: block;
    margin: 0 auto;

    & {
      h1 {
        font-size: 1.25rem;
      }
      h1,
      h2 {
        text-align: center;
      }
    }
  }
`
export const DesktopAvatar = styled.div`
  h2 {
    display: none;
  }

  @media all and (max-width: ${SMALL_BREAKPOINT}) {
    display: none;
  }
`
export const PasswordWrapper = styled.div`
  position: relative;

  img {
    position: absolute;
    top: 0.625rem;
    right: 1rem;
    cursor: pointer;
  }

  span {
    font-weight: 400;
    font-size: 12px;
    line-height: 22px;
    color: ${colors.alert};
    margin-bottom: 0;
    padding-top: 0.25rem;
  }
`
export const TagsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding-top: 1rem;

  > div {
    margin-right: 0.5rem;
    margin-bottom: 0.5rem;
  }
`
export const Tag = styled.div`
  height: 2.25rem;
  background: ${colors.black1};
  border-radius: 4.375rem;
  color: white;
  padding: 0 1.875rem 0 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 1;
  cursor: pointer;
  position: relative;

  > svg {
    position: absolute;
    right: 0.5rem;
    fill: white;
  }
`
export const MobileLogout = styled.div`
  display: none;

  @media all and (max-width: ${SMALL_BREAKPOINT}) {
    display: block;
    font-weight: 400;
    font-size: 1rem;
    line-height: 1.625rem;
    color: ${colors.black1};
    text-align: left;
    cursor: pointer;
    padding-top: 0.875rem;
    padding-bottom: 7rem;

    img {
      margin-right: 1rem;
    }
  }
`



// WEBPACK FOOTER //
// ./src/components/Profile/Profile.style.tsx